import React from "react";
import InformationPage from "components/shared/InformationPage";
import ApiInformationPage from "models/data/api/ApiInformationPage";
import withApollo from "components/higher-order/withApollo";
import PageContainer from "components/containers/PageContainer";

function Privacy() {
    return (
      <PageContainer>
        <InformationPage page={ApiInformationPage.pages.PRIVACY_POLICY} />
      </PageContainer>
    );
}

export default withApollo(Privacy);
